import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8wgak58597: FaireBrandEntity = {
  token: "b_8wgak58597",
  type: "brand",
  name: "Wholesale Accessory Market",
  avatarUrl:
    "https://cdn.faire.com/fastly/262f08632ccaaa74939f1d188dccb5c603cd2be5825b8a96bc6458ccb36002f1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/475a43bc5c90fc224b956f204ceec179feab171b48b689b579f9eae4812cf077.png",
  logoUrl:
    "https://cdn.faire.com/fastly/262f08632ccaaa74939f1d188dccb5c603cd2be5825b8a96bc6458ccb36002f1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/475a43bc5c90fc224b956f204ceec179feab171b48b689b579f9eae4812cf077.png",
  location: "Hueytown, AL, USA",
  minimumOrderDollars: 75,
  rating: 4.9,
  reviewCount: 51,
  isTopShop: true,
  isInsider: true,
  description:
    "Wholesale Accessory Market started as a two-person family operation and has become one of the largest wholesale markets of its kind in America. Our company operates according to Christian principles, and we credit our success to staying true to our values.\n\nWe hope that through our hard work and dedication to your success, we can be the wholesale market to help you give your customers fun and unique shopping experiences with our extensive inventory of wholesale apparel and accessories.  \n\nWith plenty of hard work and perseverance, Wholesale Accessory Market, Inc has become one of the largest fashion accessory wholesalers in the United States. Our customers, fashion boutiques, gift shops, salons, hometown pharmacies as well as thousands of self-employed independent distributors, can be found in every state in the country.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:00.108Z",
    importedBy: "entity-db-cli",
  },
};
